module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "base-text-copy"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "input",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCopy($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "copy-button md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCopy($event)
      }
    }
  }, [_c('md-icon', [_vm._v("content_copy")]), _vm._v(" "), (_vm.tooltip) ? _c('md-tooltip', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed8fdc16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseTextCopy.vue
// module id = 1027
// module chunks = 1